<div class="buscar-filtrar">
  <app-buscar *ngIf="moduloActual != 'usuarios' && moduloActual != 'lugares'" [formGroup]="filtrosForm" (onLimpiar)="quitarPalabrasClave()"></app-buscar>
  <div *ngIf="moduloActual === 'visitantes' || moduloActual === 'pagos' || moduloActual === 'usuarios'" class="filtro-boton-visitante">
    <app-filtro-fecha *ngIf="moduloActual === 'visitantes' || moduloActual === 'pagos'" [fechasForm]="filtrosForm">
    </app-filtro-fecha>
    <!-- <a *ngIf="moduloActual === 'visitantes' && usuarioEsCelador" routerLink="/visitantes/nuevo">
      <button>
        Nuevo visitante
      </button>
    </a> -->
    <a *ngIf="moduloActual === 'pagos' && !usuarioEsCelador">
      <button (click)="mostrarModalCargarPagos()">
        Cargar pagos
      </button>
    </a>
    <a *ngIf="moduloActual === 'usuarios'" routerLink="/usuarios/subida-masiva">
      <button>
        Subida Masiva
      </button>
    </a>
  </div>
</div>

<div *ngIf="moduloActual === 'visitantes'" class="opciones-visitas">

  <div [ngClass]="{
    'opcion-visitas-activa': tipoVisitas === TIPOS_VISITAS.TODOS,
    'opcion-visitas': tipoVisitas !== TIPOS_VISITAS.TODOS
  }" (click)="cambiarTipoVisitas(TIPOS_VISITAS.TODOS)">TODOS<hr/>
  </div>

  <div [ngClass]="{
    'opcion-visitas-activa': tipoVisitas === TIPOS_VISITAS.PENDIENTE,
    'opcion-visitas': tipoVisitas !== TIPOS_VISITAS.PENDIENTE
  }" (click)="cambiarTipoVisitas(TIPOS_VISITAS.PENDIENTE)">VISITAS PENDIENTES<hr/>
  </div>

  <div [ngClass]="{
    'opcion-visitas-activa': tipoVisitas === TIPOS_VISITAS.ENROLADO,
    'opcion-visitas': tipoVisitas !== TIPOS_VISITAS.ENROLADO
  }" (click)="cambiarTipoVisitas(TIPOS_VISITAS.ENROLADO)">ENROLADOS<hr/>
  </div>

  <div [ngClass]="{
    'opcion-visitas-activa': tipoVisitas === TIPOS_VISITAS.ENPLANTA,
    'opcion-visitas': tipoVisitas !== TIPOS_VISITAS.ENPLANTA
  }" (click)="cambiarTipoVisitas(TIPOS_VISITAS.ENPLANTA)">EN PLANTA<hr/>
  </div>

  <div [ngClass]="{
    'opcion-visitas-activa': tipoVisitas === TIPOS_VISITAS.SALIDA,
    'opcion-visitas': tipoVisitas !== TIPOS_VISITAS.SALIDA
  }" (click)="cambiarTipoVisitas(TIPOS_VISITAS.SALIDA)">SALIDA<hr/>
  </div>

  <div [ngClass]="{
    'opcion-visitas-activa': tipoVisitas === TIPOS_VISITAS.RECHAZADO,
    'opcion-visitas': tipoVisitas !== TIPOS_VISITAS.RECHAZADO
  }" (click)="cambiarTipoVisitas(TIPOS_VISITAS.RECHAZADO)">RECHAZADO<hr/>
  </div>

  <div [ngClass]="{
    'opcion-visitas-activa': tipoVisitas === TIPOS_VISITAS.HISTORIAL,
    'opcion-visitas': tipoVisitas !== TIPOS_VISITAS.HISTORIAL
  }" (click)="cambiarTipoVisitas(TIPOS_VISITAS.HISTORIAL)">HISTORIAL<hr/>
  </div>
  
</div>

<div *ngIf="moduloActual === 'pagos'" class="opciones-visitas">
  <div [ngClass]="{
    'opcion-visitas-activa': tipoPagos === TIPOS_PAGOS.ACTIVOS,
    'opcion-visitas': tipoPagos !== TIPOS_PAGOS.ACTIVOS
  }" (click)="cambiarTipoPagos(TIPOS_PAGOS.ACTIVOS)">ACTIVOS<hr/></div>
  <div [ngClass]="{
    'opcion-visitas-activa': tipoPagos === TIPOS_PAGOS.HISTORIAL,
    'opcion-visitas': tipoPagos !== TIPOS_PAGOS.HISTORIAL
  }" (click)="cambiarTipoPagos(TIPOS_PAGOS.HISTORIAL)">HISTORIAL<hr/></div>
</div>

<div class="tabla-general" *ngIf="!cargandoDatos && data.length > 0" >
  <table mat-table [dataSource]="data">
    <ng-container *ngFor="let columna of displayedColumns; let i = index" matColumnDef={{columna.nombre}}>
      <th mat-header-cell *matHeaderCellDef>{{columna.titulo}}</th>

      <ng-container *ngIf="moduloActual === 'pagos'">
        <td mat-cell *matCellDef="let row; let k = index;" mat-icon-button [attr.matMenuTriggerFor]="(moduloActual === 'pagos') ? null : menu">
          
          <span *ngIf="columna.nombre !== 'verificacionPago'">
            {{row[columna.valueFieldName] || "Sin asignar"}}
          </span>
          
          <div *ngIf="columna.nombre === 'verificacionPago'" class="pago" 
                [ngStyle]="{cursor: row[columna.valueFieldName] === ESTADOS_PAGO.VERIFICAR ? 'pointer' : 'auto'}"
               [ngClass]="{verificado: row[columna.valueFieldName] === ESTADOS_PAGO.VERIFICADO, verificar: row[columna.valueFieldName] === ESTADOS_PAGO.VERIFICAR, pendiente: row[columna.valueFieldName] === ESTADOS_PAGO.PENDIENTE}"
               (click)="(row[columna.valueFieldName] === ESTADOS_PAGO.VERIFICAR) && mostrarModalVerificarPago(row)">
            <mat-icon *ngIf="row[columna.valueFieldName] === ESTADOS_PAGO.VERIFICADO">check</mat-icon>
            <div class="circle" *ngIf="row[columna.valueFieldName] === ESTADOS_PAGO.PENDIENTE"></div>
  
            <span *ngIf="row[columna.valueFieldName] === ESTADOS_PAGO.VERIFICADO" >Verificado</span>
            <span *ngIf="row[columna.valueFieldName] === ESTADOS_PAGO.VERIFICAR" >Verifícar</span>
            <span *ngIf="row[columna.valueFieldName] === ESTADOS_PAGO.PENDIENTE" >Pendiente</span>
          </div>
  
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item (click)="editar(row.id)">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container *ngIf="moduloActual !== 'pagos'">
        <td mat-cell *matCellDef="let row; let k = index;" mat-icon-button [matMenuTriggerFor]="menu">
          <span *ngIf="columna.nombre !== 'estado'">
            {{row[columna.valueFieldName] || "Sin asignar"}}
          </span>
          <span *ngIf="columna.nombre === 'estado'">
            {{row[columna.valueFieldName] | tipoVisitaNombre}}
          </span>
          <mat-menu #menu="matMenu" xPosition="before">
            <button *ngIf="moduloActual === 'visitantes' || moduloActual === 'citofonia'"  mat-menu-item (click)="editar(row.id)">
              <mat-icon>more_horiz</mat-icon>
              <span>Ver</span>
            </button>
            <button *ngIf="moduloActual !== 'visitantes' && moduloActual !== 'citofonia' && moduloActual !== 'usuarios'"  mat-menu-item (click)="editar(row.id)">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
            <button *ngIf="moduloActual === 'usuarios'" mat-menu-item (click)="reenviarCorreo(row)">
              <mat-icon>email</mat-icon>
              <span>Reenviar correo</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsNames"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsNames;"></tr>
  </table>
  <div class="paginador">
    <div class="paginas">
      <mat-icon (click)="paginaAnterior()" id="flecha-anterior" *ngIf="paginaActual > 0"  class='opcion-paginador' aria-hidden="false" aria-label="Página anterior">arrow_left</mat-icon>
      <div *ngFor="let item of numSequence(paginaActual+1); let i = index;"
          [ngClass]="paginaActual === i ? 'opcion-paginador-activa' : 'opcion-paginador'"
          (click)="actualizarPagina(i)">
          {{i+1}}
      </div>
      <mat-icon 
        (click)="paginaSiguiente()"
        id="flecha-siguiente"
        *ngIf="(elementosPorPagina === data.length) && (paginaActual !== ultimaPagina)"
        class='opcion-paginador'
        aria-hidden="false"
        aria-label="Siguiente página">arrow_right</mat-icon>
    </div>
  </div>
</div>
<mat-spinner *ngIf="cargandoDatos"></mat-spinner>

<div class="mensaje-sin-datos" *ngIf="!cargandoDatos && data.length === 0">
  No hay datos que se ajusten a estos criterios, por favor ajusta los filtros
</div>